import { formatToPriceType } from 'state/secondaryMarket/live/live.selector';
import type { LiveTradeState } from 'state/secondaryMarket/live/trade/trade.model';
import { tradeSelectorsFactory } from 'state/secondaryMarket/shared/trade/trade.selector';
import type { AppState } from 'state/state.model';

const selectors = tradeSelectorsFactory('live', {});

const select = (state: AppState, tabId: string) => selectors.select(state, tabId) as LiveTradeState | undefined;
const getTradePriceFormatted = (state: AppState, tabId: string) =>
  formatToPriceType(state, tabId, getTradePrice(state, tabId));

const getTradePrice = (state: AppState, tabId: string) => select(state, tabId)?.tradingPrice;
const getSettlementPrice = (state: AppState, tabId: string) => select(state, tabId)?.settlementPrice;
const getTradeAccruedInterest = (state: AppState, tabId: string) => select(state, tabId)?.accruedInterest;

export const liveTradeSelectors = {
  ...selectors,
  getTradePrice,
  getTradePriceFormatted,
  getTradeAccruedInterest,
  getSettlementPrice,
};
